<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">The telling of this story started as a discussion around the table during a Sunday dinner with extended family. I was talking about a letter that seemed to have a good story and how we couldn’t figure out what it was referencing and also had trouble reading the text. My mother-in-law, Barbara, offered to read the letter and others we had from the same era and transcribe them.</p>
<p class="indent">Once I found the beginnings of a story that had not been widely told, I reached out far and wide and am grateful to the incredibly dedicated staffs and volunteers at the California State Archives; the Sacramento Room of the Sacramento County Public Library; the El Dorado County Historical Museum; the Folsom History Museum; the San Joaquin County Historical Museum; the Contra Costa Historical Society; April Moore, who wrote about the executions at Folsom Prison, William Berg, who writes extensively about the history of Sacramento; and Jim Brown and Duke Juanitas from the Folsom Prison Museum.</p>
<p class="indent">Once the story was coming together, I am grateful to Annette Kassis and Rodi Lee, who provided professional perspective as early readers to this first-time writer, and Laurie Krill and The History Press, who believed in this story and helped bring it to print.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgement.vue?21e5266b